<template>
  <div class="controlpanel-page controlpanel-page-pdt0">
    <div class="reportmanagementtopbar">
      <h1>
        <span>行业报告管理</span>
        <div class="changereportlanguage">
          <el-radio v-model="reportlanguage" label="cn">中文</el-radio>
          <el-radio v-model="reportlanguage" label="en">English</el-radio>
        </div>       
      </h1>
      <el-divider></el-divider>
    </div>
    <div class="controlpanel-container reportmanagement">
      <div class="reportmanagement-body">
        <div class="reportmanagement-body-list">
          <div class="reportmanagement-body-addindustry">
            <el-button @click="addindustryshow=true"><i class="el-icon-document-add"></i></el-button>
          </div><!-- 新增行业 -->

          <div class="reportmanagement-body-list-row" :style="'transition:margin-top 1s; margin-top:-' + listheight * scrolls + 'px;'">
            <div v-for="(item, index) in reportcategory" :id="'category' + index" class="reportmanagement-body-list-item" :key="index">
              <div class="reportmanagement-body-list-item-content">
                <div class="reportitemheader">
                  <span>{{ reportlanguage == 'cn' ? item.name_cn : item.name_en}}</span>
                  <div class="reportitembtngroup">
                    <el-button @click="editIndustry(item.iid, item.name_cn, item.name_en)"><i class="el-icon-edit"></i></el-button>
                    <el-popconfirm title="确认删除吗？" @onConfirm="deleteIndustry(item.iid)">
                      <el-button slot="reference"><i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                  </div>
                </div>
                <div class="reportitembody">
                  <div class="reportitembody-list">
                    <el-carousel height="170px" :autoplay="false" arrow="nerver" indicator-position="outside">
                      <el-carousel-item v-for="(_item, _index) in item.categoryListSlide" :key="_index">
                        <div class="reportitembody-item" v-for="_items in _item" :key="_items.cid">
                          <el-checkbox v-model="_items.is_display" @change="setDisplay(_items.cid, _items.is_display)">{{ _items.name_cn }}</el-checkbox>
                          <div class="reportitembtngroup">
                            <el-button @click="editReport(_items.cid)"><i class="el-icon-edit"></i></el-button>
                            <el-popconfirm title="确认删除吗？" @onConfirm="deleteReport(_items.cid)">
                              <el-button slot="reference"><i class="el-icon-delete"></i></el-button>
                            </el-popconfirm>
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </div><!--reportitembody-->
              </div>
            </div>

          </div><!-- 行业列表 -->
  
          <div 
            class="scrollcategorylist" 
            v-if="showscrollcategorybtn" 
            :style="'padding-top:' + (listheight/2 - (25 * reportcategoryrows)/2) + 'px;'"
          >
            <el-button
              :class="currentrow == item ? 'activescrollbtn' : ''"
              v-for="(item, index) in reportcategoryrows" 
              :key="index" 
              @click="scrollcategory(item-1)"
            >
            </el-button>
          </div><!-- 垂直切换 -->

        </div>
      </div>

      <div class="reportmanagement-footer">
        <el-button @click="gotoAddIndustryReportPage"><i class="el-icon-circle-plus"></i> 新建行业报告</el-button>
      </div>

    </div>

    <!-- 弹窗 -->
    <el-dialog
      :title="addindustryiid == '' ? '增加行业' : '修改行业'"
      custom-class="addindustrydialog"
      :visible.sync="addindustryshow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :show-close="true"
      @close="resetAddindustryname"
      width="300px"
      top="30vh">
      <div class="addindustryform">
        <el-form label-position="left" label-width="100px" size="mini">
          <el-form-item label="行业名称 - 中文">
            <el-input v-model="addindustryname.name_cn"></el-input>
          </el-form-item>
          <el-form-item label="行业名称 - 英文">
            <el-input v-model="addindustryname.name_en"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="addindustryiid == ''" @click="confirmAddIndustry">确定</el-button>
        <el-button type="primary" v-if="addindustryiid > 0" @click="confirmEditIndustry">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return{
      addindustryshow: false,
      addindustryname: {
        name_cn: '',
        name_en: ''
      },
      addindustryiid: '',
      reportlanguage: 'cn',
      reportcategory: [],
      reportcategoryrows: 1,
      scrolls: 0,
      listheight: window.innerHeight/1 - 160,
      showscrollcategorybtn: false,
      currentrow: 1,
      checked: []
    }
  },
  mounted(){
    this.getIndustryList()
  },
  methods: {

    /**
     * 重置添加行业表单
     */
    resetAddindustryname: function(){
      this.addindustryshow = false
      this.addindustryiid = ''
      this.addindustryname.name_cn = ''
      this.addindustryname.name_en = ''
    },

    /**
     * 右侧滚动
     */
    scrollcategory: function(i){
      this.scrolls = i
      this.currentrow = i + 1
    },

    /**
     * 跳转到新建行业报告
     */
    gotoAddIndustryReportPage: function(){
      this.$router.push({ name: "ReportManagementNew" })
    },
    
    /**
     * 确认新增行业
     */
    confirmAddIndustry: function(){
      let that = this
      let formdata = that.addindustryname
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/industry-add' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(formdata),
        contentType: "application/json",
        success: function(data) {
          console.log('confirmAddIndustry', data)
          if(data.code===200){
            that.resetAddindustryname()
            that.$message({
              showClose: true,
              message: data.error,
              type: 'success'
            })
            that.getIndustryList()
          }else{
            that.$message({
              showClose: true,
              message: data.error,
              type: 'error'
            })
          }
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    /**
     * 获取行业列表
     */
    getIndustryList: function(){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/index' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log(rex)
          let lists = rex.data.data
          lists.forEach(item => {
            item.categoryList.forEach( _item => {
              _item.is_display = _item.is_display/1 === 0 ? false : true
            })
            item.categoryListSlide = that.splitArr(item.categoryList)
          })
          that.reportcategory = lists
          that.showscrollcategorybtn = that.reportcategory.length > 10 ? true : false
          that.reportcategoryrows = Math.ceil(that.reportcategory.length/10)
          console.log(that.reportcategory)
        },
        error: function(response) {
          console.log(response)
        }
      })                 
    },

    /**
     * 删除行业
     */
    deleteIndustry: function(iid){
      let that = this
      let formdata = {
        iid: iid
      }
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/industry-delete' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(formdata),
        contentType: "application/json",
        success: function(data) {
          console.log('deleteIndustry', data)
          if(data.code===200){
            that.$message({
              showClose: true,
              message: data.error,
              type: 'success'
            })
            that.getIndustryList()
          }else{
            that.$message({
              showClose: true,
              message: data.error,
              type: 'error'
            })
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 修改行业
     */
    editIndustry: function(iid, cn, en){
      let that = this
      that.addindustryiid = iid
      that.addindustryname.name_cn = cn
      that.addindustryname.name_en = en
      that.addindustryshow = true
    },

    /**
     * 确认修改行业
     */
    confirmEditIndustry: function(){
      let that = this
      let formdata = {
        iid: that.addindustryiid,
        name_cn: that.addindustryname.name_cn,
        name_en: that.addindustryname.name_en,
      }
      console.log(formdata)
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/industry-edit' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(formdata),
        contentType: "application/json",
        success: function(data) {
          console.log('confirmEditIndustry', data)
          if(data.code===200){
            that.resetAddindustryname()
            that.$message({
              showClose: true,
              message: data.error,
              type: 'success'
            })
            that.getIndustryList()
          }else{
            that.$message({
              showClose: true,
              message: data.error,
              type: 'error'
            })
          }
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    /**
     * 删除行业报告
     */
    deleteReport: function(cid){
      let that = this
      let formdata = {
        cid: cid/1
      }
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/delete' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(formdata),
        contentType: "application/json",
        success: function(data) {
          console.log('deleteIndustry', data)
          if(data.code===200){
            that.$message({
              showClose: true,
              message: data.error,
              type: 'success'
            })
            that.getIndustryList()
          }else{
            that.$message({
              showClose: true,
              message: data.error,
              type: 'error'
            })
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 修改行业报告
     */
    editReport: function(cid){
      this.$router.push({ name: "ReportManagementEdit", params: {Cid: cid} })
    },

    /**
     * 报告显示隐藏
     */
    setDisplay: function(cid, type){
      let that = this
      let formdata = {
        cid: cid,
        is_display: type === true ? 1 : 0
      }
      console.log(formdata)
      let url = 'http://dashboard.api.trade-intelligence.com/admin/category/display' + 
                '?token=' + that.getLocalStorage('admintoken')
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(formdata),
        contentType: "application/json",
        success: function(data) {
          console.log('confirmEditIndustry', data)
          if(data.code===200){
            that.resetAddindustryname()
            that.$message({
              showClose: true,
              message: data.error,
              type: 'success'
            })
          }else{
            that.$message({
              showClose: true,
              message: data.error,
              type: 'error'
            })
          }
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    splitArr: function(arr){
      let len = arr.length
      let num = 5
      let index = 0
      let _arr = []
      for(let i=0; i<len; i++){
        if(i % num === 0 && i !== 0){
          _arr.push(arr.slice(index, i))
          index = i
        }
        if(i + 1 === len){
          _arr.push(arr.slice(index, i+1))
        }
      }
      return _arr
      // let _arr = []
      // if(arr.length <= 5){
      //   _arr[0] = arr
      //   return _arr
      // }
      // if(arr.length > 5){
      //   for(let j=0; j<Math.ceil(arr.length/5); j++){
      //     _arr[j] = arr.slice(0, 5)
      //   }
      //   return _arr
      // }
    },

  }
}
</script>